import styled from "styled-components";
import { PageHeader } from "./PageHeader";
import { PageFooter } from "./PageFooter";

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  background: radial-gradient(rgb(255 255 255) 0%, rgb(147 147 147) 100%);
`;

const Main = styled.div`
  flex-grow:1;
`;

interface PageSharedLayoutInterface {
  children: React.ReactNode;
}

export const PageSharedLayout = ({ children }: PageSharedLayoutInterface) => {
  return (
    <Layout>
      <PageHeader></PageHeader>
      <Main>{children}</Main>
      <PageFooter></PageFooter>
    </Layout>
  );
};
